<div class="login-background">
  <div class="image-container">
    <div class="logo">
      <a href="#">
        <img [src]="'assets/images/logo2.png' | baseUrl" alt="Logo empresa" />
      </a>
    </div>
    <div class="content">
      <h1>Portal Vesta</h1>
      <span>
        Um novo portal para gerenciamento de serviços.
      </span>
    </div>
    <div class="footer">
      <div>
        Copyright &copy; 2025 <br />
        <small>Sistema desenvolvido por: <a target="_blank" href="https://sequoialog.com.br/">TI Sequoia</a></small>
      </div>
    </div>
  </div>
  <div class="login-container">
    <!-- Loading Element -->
    <div class="signin-wrapper" *ngIf="isLoading">
      <div class="row">
        <div class="col-12">
          <div class="signin-loading">
            <mat-progress-spinner
              strokeWidth="4"
              [diameter]="60"
              [color]="color"
              [value]="value"
            >
            </mat-progress-spinner>
          </div>
        </div>
      </div>
    </div>
    <!-- Login screen -->
    <div class="signin-wrapper" *ngIf="login && !isLoading">
      <div class="row">
        <div class="col-12">
          <div class="signin-header">
            <div class="logo mobile">
              <a href="#">
                <img
                  [src]="'assets/images/logo2.png' | baseUrl"
                  alt="Logo empresa"
                />
              </a>
            </div>
            <h2>Credenciais para acesso</h2>
            <hr />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>Insira seus dados para ter acesso ao sistema.</p>
          <div class="signin-general">
            <form [formGroup]="formLogin" (ngSubmit)="onLogin()">
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>Digite seu Logon</mat-label>
                  <input
                    matInput
                    placeholder="Digite seu nome de usuário"
                    appAutoFocus
                    formControlName="usuario"
                    (change)="resetLoginAttemps()"
                    #inputEmail
                    maxlength="100"
                    required
                    [(ngModel)]="elUsuario"
                  />
                  <mat-error *ngIf="usuario.invalid">
                    {{ getErrorMessage() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field appearance="outline" class="password-input">
                  <mat-label>Digite sua senha</mat-label>
                  <input
                    matInput
                    placeholder="Digite sua senha"
                    [(ngModel)]="elPass"
                    name="elPass"
                    formControlName="password"
                    [type]="hide ? 'password' : 'text'"
                    required
                    #inputPassword
                  />
                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide"
                  >
                    <mat-icon>
                      {{ hide ? "visibility_off" : "visibility" }}
                    </mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <div *ngIf="enableCaptcha" class="recaptcha-wrapper d-flex" style="justify-content: space-around;">
                <re-captcha
                  #captchaRef="reCaptcha"
                  (resolved)="recaptchaResolved($event)"
                ></re-captcha>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <p class="text-right">
                  <a class="a" (click)="forgetPassword()">Esqueceu a senha?</a>
                </p>
              </div>
              <button mat-flat-button color="primary" [disabled]="disableAccess || formLogin.invalid">
                Acessar <mat-icon>exit_to_app</mat-icon>
              </button>
              <div class="signin-busy-indicator" *ngIf="isBusy">
                <div class="lds-ring"></div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Forget Password screen-->
    <div class="signin-wrapper" *ngIf="fPassword && !isLoading">
      <div class="row">
        <div class="col-12">
          <div class="signin-header">
            <h2>Recuperação de senha</h2>
            <hr />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="signin-general">
            <p>Informe seu usuário.</p>
            <form
              [formGroup]="formRecoverPassword"
              (ngSubmit)="forgotPassword()"
            >
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>Digite seu nome de usuário</mat-label>
                  <input
                    matInput
                    placeholder="Digite seu nome de usuário"
                    [(ngModel)]="recoverUser"
                    formControlName="recoverPasswordUser"
                    maxlength="100"
                    required
                    #inputEmail
                  />
                </mat-form-field>
              </div>
              <!-- <div class="recaptcha-wrapper" [hidden]="loginAttempts < 3">
                  <re-captcha #captchaRef="reCaptcha" (resolved)="recaptchaResolved($event)"></re-captcha>
                </div> -->
              <div style="display: flex; justify-content: space-between;"></div>
              <button
                *ngIf="!isBusy"
                mat-flat-button
                color="primary"
                type="submit"
                [attr.disabled]="isBusy ? 'disabled' : null"
              >
                Enviar
              </button>
              <p class="text-center">
                <a class="a" (click)="defaultForm()">Voltar</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Code verify screen-->
    <div class="signin-wrapper" *ngIf="secretCodeVerify && !isLoading">
      <div class="row">
        <div class="col-12">
          <div class="signin-header">
            <h2>Código de verificação</h2>
            <hr />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="signin-general">
            <p>Digite o código que enviamos ao seu e-mail</p>
            <form [formGroup]="formCodeVerify" (ngSubmit)="verifyCode()">
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>Digite o código</mat-label>
                  <input
                    matInput
                    placeholder="Digite o código"
                    [(ngModel)]="secretCode"
                    formControlName="secretCodeValidation"
                    name="secretCode"
                    maxlength="6"
                    required
                    #inputEmail
                  />
                </mat-form-field>
              </div>
              <div style="display: flex; justify-content: space-between;"></div>
              <button
                *ngIf="!isBusy"
                mat-flat-button
                color="primary"
                type="submit"
                [attr.disabled]="isBusy ? 'disabled' : null"
              >
                Enviar
              </button>
              <p class="text-center">
                <a class="a" (click)="defaultForm()">Voltar</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Autenticação 2 fatores -->
    <div class="signin-wrapper" *ngIf="secretCode2fa && !isLoading">
      <div class="row">
        <div class="col-12">
          <div class="signin-header">
            <h2>Código de verificação</h2>
            <hr />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="signin-general">
            <p>Digite o código que enviamos ao seu e-mail</p>
            <form [formGroup]="formCodeVerify2fa" (ngSubmit)="verifyCodeLogin()">
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>Digite o código</mat-label>
                  <input
                    matInput
                    placeholder="Digite o código"
                    [(ngModel)]="secretCode2faToken"
                    formControlName="secretCodeValidation2fa"
                    name="secretCode"
                    maxlength="6"
                    required
                    #inputEmail
                  />
                </mat-form-field>
              </div>
              <div style="display: flex; justify-content: space-between;"></div>
              <button
                *ngIf="!isBusy"
                mat-flat-button
                color="primary"
                type="submit"
                [attr.disabled]="isBusy ? 'disabled' : null"
              >
                Enviar
              </button>
              <p class="text-center">
                <a class="a" (click)="defaultForm()">Voltar</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="signin-wrapper" *ngIf="recoverPassword && !isLoading">
      <div class="row">
        <div class="col-12">
          <div class="signin-header">
            <h2>Cadastro de nova senha</h2>
            <hr />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="signin-general">
            <p>Digite sua nova senha.</p>
            <form [formGroup]="formNewPassword" (ngSubmit)="updatePassword()">
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>Nova Senha</mat-label>
                  <input
                    matInput
                    placeholder="Digite a nova senha"
                    name="newPass"
                    formControlName="newPasswordValidation"
                    [(ngModel)]="newPass"
                    [type]="hide ? 'password' : 'text'"
                    #inputPassword
                  />
                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide"
                  >
                    <mat-icon>
                      {{ hide ? "visibility_off" : "visibility" }}
                    </mat-icon>
                  </button>
                </mat-form-field>
                <app-password-meter [password]="newPass" (buttonPassword)="passwordValid($event)"></app-password-meter>
              </div>
              <div>
                <mat-form-field appearance="outline">
                  <mat-label>Confirme sua Senha</mat-label>
                  <input
                    matInput
                    placeholder="Confirme sua nova senha"
                    [(ngModel)]="confirmNewPass"
                    name="confirmNewPass"
                    formControlName="confirmNewPasswordValidation"
                    [type]="hide ? 'password'  : 'text'"
                    #inputPassword
                  />
                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide"
                  >
                    <mat-icon>
                      {{ hide ? "visibility_off" : "visibility" }}
                    </mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <!-- <div class="recaptcha-wrapper" [hidden]="loginAttempts < 3">
                <re-captcha
                  #captchaRef="reCaptcha"
                  (resolved)="recaptchaResolved($event)"
                ></re-captcha>
              </div> -->
              <button

                *ngIf="!isBusy"
                mat-flat-button
                color="primary"
                [disabled]="isBusy || !newPass || !confirmNewPass || !passwordIsValid"
                type="submit"
              >
                Resetar
              </button>
              <p class="text-center">
                <a class="a" (click)="defaultForm()">Voltar</a>
              </p>
              <!-- <div class="error-message"  *ngIf="f.confirmNewPasswordValidation.errors.mustMatch">
                          As senhas não coincidem.
                      </div> -->
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div>
        Copyright &copy; 2025 - Sistema desenvolvido por: TI Sequoia
      </div>
    </div>
  </div>
</div>
